<template>
  <div class="content-wrap">
    <div v-if="!browserIsPermitted">
      <div id="unsupported-browser">
        <p>{{$t('signin.ua_message')}}</p>
        <p>{{$t('signin.ua_message2')}}</p>
      </div>
    </div>
    <img class="imgcontainer" src="https://beta.tfabconnect.com/img/ogpimage.png">

    <nav class="auth-select-box">
      <b-tabs expanded v-model="tab">
        <b-tab-item :label="this.$t('signin.signin')" icon="login-variant"></b-tab-item>
        <b-tab-item :label="this.$t('signin.signup')" icon="account-plus"></b-tab-item>
      </b-tabs>

      <div v-if="tab == 0" class="signin">
        <ul class="auth-select-list">
          <li><a @click="signin()">{{$t("signin.sns_signin")}}</a></li>
        </ul>
      </div>

      <div v-else class="signup">
        <div class="terms-box">
          <iframe v-if="this.$store.state.preferences.locale == 'ja'" class="terms-of-use" src="https://beta.tfabconnect.com/inner-tos.html" />
          <iframe v-else class="terms-of-use" src="https://beta.tfabconnect.com/en/inner-tos.html" />
        </div>
        <div class="checkbox-wrapper">
          <b-checkbox v-model="isAgree" true-value=1 false-value=0>{{$t('signin.consent')}}</b-checkbox>
        </div>
        <ul class="auth-select-list" v-if="this.isAgree == 1">
          <li><a @click="signup()">{{$t("signin.sns_signup")}}</a></li>
          <li><a @click="startWithoutLogin()">{{$t("signin.start")}}</a></li>
        </ul>
        <ul class="auth-select-list button-disable" v-else>
          <li><a>{{$t("signin.sns_signup")}}</a></li>
          <li><a>{{$t("signin.start")}}</a></li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import platform from 'platform'
const queryString = require('query-string');

export default {
    data() {
      return {
        browserIsPermitted: false,
        isAgree: 0,
        isWelcome: this.$store.state.preferences.isWelcome,
        tab: 1,
        isSignin: true
      }
    },
    mounted() {
        if(this.isWelcome == "false"){
          this.tab = 0
        }else{
          this.tab = 1
        }
        // Edgeがchromiumになった
        // see also: https://blogs.windows.com/japan/2020/01/16/new-year-new-browser-the-new-microsoft-edge-is-out-of-preview-and-now-available-for-download/
        this.browserIsPermitted = platform.name === "Chrome" || platform.name === "Microsoft Edge"
    },
    methods: {
        redirectToLogin() {
          const hostname = 'auth.tfabconnect.com'
          const pathname = '/login'
          const query = {
              'client_id': '1nsderidh969374vl5mvitinhs',
              'response_type': 'code',
              'scope': 'phone+email+openid+profile',
              'redirect_uri': `${location.protocol}//${location.host}/dashboard/`
          }
          location.href = `https://${hostname}${pathname}?${queryString.stringify(query, {encode: false})}`
        },
        startWithoutLogin() {
            this.$store.dispatch('account/registerUser')
            .then(() => {
                this.$store.commit('preferences/setPreferences', {isWelcome: 'true'})
                this.$router.push('/dashboard', () => {})
            })
            .catch(() => {
              this.$buefy.toast.open({
                duration: 7000,
                message: this.$t('app.dashboard.graph.error_warning'),
                position: "is-top",
                type: "is-danger"
              })
              return Promise.resolve()
            })
        },
        signin() {
          this.$store.commit('preferences/setPreferences', {isWelcome: 'false'})
          this.redirectToLogin()
        },
        signup() {
          this.$store.commit('preferences/setPreferences', {isWelcome: 'true'})
          this.redirectToLogin()
        }
    }
}
</script>
<style scoped>
.content-wrap {
  margin: auto;
}
.imgcontainer {
  display: block;
  margin: 20px auto 50px auto;
}
@media(max-width: 485px) {
  .imgcontainer {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: 50% 50%;
  }
}
.auth-select-box {
  max-width: 900px;
  margin: 50px auto auto auto;
}
.signin{
  max-width: 900px;
  position: relative;
}
.auth-select-list {
  display: flex;
  padding: 20px;
  justify-content: center;
  margin-bottom: 60px;
}
.auth-select-list li {
  flex: 1;
  margin: 20px;
}
@media(max-width: 485px) {
  .auth-select-list li {
    margin: 10px;
  }
}
.auth-select-list li a {
  display: block;
  position: relative;
  padding: 20px 15px;
  border-radius: 4px;
  background: #2c6ac4;
  color: #fff;
  font-size: 1.125rem;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  line-height: 1.4;
}
@media(max-width: 485px) {
  .auth-select-list li a {
    padding: 20px 0px;
    font-size: .8rem;
  }
}
.button-disable li a {
  background-color: buttonface;
  color: rgb(170, 170, 170);
  pointer-events: none;
}
#unsupported-browser {
  font-size: 1.4rem;
  margin: 40px 0 20px 0;
  text-align: center;
  color: red;
}
.terms-box{
  background-color: #EEEEEE;
  height: 400px;
  white-space: nowrap;
}
.terms-of-use {
  width: 100%;
  height: 100%;
}
.checkbox-wrapper {
  margin: 10px 0 10px 15px;
}
</style>
